import React, { useState, useEffect } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { AdapterMomentJalaali } from "@mui/x-date-pickers/AdapterMomentJalaali";
import moment from "moment-jalaali";

moment.loadPersian({ usePersianDigits: false });

const PersianDatePicker = ({ value, label = "تاریخ", onChange }) => {
  const [selectedDate, setSelectedDate] = useState(
    value ? moment(value) : null
  );

  // Update selectedDate when value prop changes
  useEffect(() => {
    if (value) {
      setSelectedDate(moment(value));
    }
  }, [value]);

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterMomentJalaali}>
      <DatePicker
        className="w-100 persian-date-picker"
        disablePast={true}
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        renderInput={(params) => <TextField {...params} />}
        slotProps={{
          nextIconButton: {
            sx: {
              marginLeft: "0px",
              marginRight: "-12px",
            },
          },
          previousIconButton: {
            sx: {
              marginLeft: "-12px",
              marginRight: "0px",
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default PersianDatePicker;
